<nz-card>
  <div [innerHTML]="content"></div>
</nz-card>
